<template>
  <aside class="sidebar-container">
    <!-- Brand Section -->
    <div class="brand-section">
      <div class="brand-logo">
        <div class="logo-inner">O‘UB</div>
      </div>
      <div class="brand-info">
        <span class="brand-name">O‘quv-uslubiy boshqarma</span>
      </div>
    </div>

    <!-- Navigation -->
    <nav class="sidebar-nav">
      <template v-for="item in filteredMenuItems" :key="item.name">
        <!-- Group Header -->
        <div class="nav-group">
          <div class="group-header" @click="toggleGroup(item.name)">
            <span class="group-icon">{{ item.icon }}</span>
            <span class="group-label">{{ item.label }}</span>
            <svg 
              class="chevron-icon" 
              :class="{ 'rotated': expandedGroups[item.name] }"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
            >
              <path d="M9 5l7 7-7 7" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>

          <!-- Child Items -->
          <transition name="expand">
            <div v-if="expandedGroups[item.name]" class="group-children">
              <template v-for="child in item.children" :key="child.name">
                <router-link
                  v-if="child.to"
                  :to="child.to"
                  class="child-link"
                  :class="{ 'active': isActive(child.to) }"
                >
                  <span class="child-dot"></span>
                  {{ child.label }}
                </router-link>
                <a
                  v-else
                  href="#"
                  class="child-link disabled"
                >
                  <span class="child-dot"></span>
                  {{ child.label }}
                </a>
              </template>
            </div>
          </transition>
        </div>
      </template>
    </nav>


  </aside>
</template>

<script>
export default {
  name: "AppSidebar",
  data() {
    return {
      userRole: "",
      expandedGroups: {
        yuklamalar: true,
        yuklamalar_oktyabr: true
      },
      menuItems: [
        {
          name: "yuklamalar",
          icon: "📋",
          label: "Yuklamalar",
          children: [
            { name: "ishchi-oquv", label: "Ishchi o'quv rejalar", to: { name: "ishchi-oquv" } },
            {
              name: "kafedra-yuklamalari",
              label: "Kafedra yuklamalari",
              to: { name: "kafedra-yuklamalari" },
            },
            { name: "kafedra-taqsimoti", label: "Kafedra taqsimoti", to: { name: "kafedra-taqsimoti" } },
            { 
              name: "yuklama-va-taqsimot", 
              label: "Yuklama va taqsimot", 
              to: { name: "yuklama-va-taqsimot" } 
            },
            { name: "shaxsiy-ish", label: "Shaxsiy ish reja", to: { name: "shaxsiy-ish-reja" } },
            { 
              name: "kafedra-vs-shaxsiy-reja", 
              label: "Kafedra vs Shaxsiy ish reja", 
              to: { name: "kafedra-vs-shaxsiy-reja" }, 
              superAdminOnly: true 
            },
            { name: "tanlov-fanlar", label: "Tanlov fanlar", to: { name: "tanlov-fanlar" } },
            { 
              name: "faoliyat-jurnali", 
              label: "Faoliyat jurnali (Audit)", 
              to: { name: "faoliyat-jurnali" }, 
              superAdminOnly: true 
            },
            { 
              name: "backup", 
              label: "Baza nusxasi (Backup)", 
              to: { name: "backup" }, 
              superAdminOnly: true 
            },
            {
              name: "sozlamalar",
              label: "Sozlamalar (Parol)",
              to: { name: "sozlamalar" },
              oquvSuperAdminOnly: true
            },
          ],
        },
        {
          name: "yuklamalar_oktyabr",
          icon: "📑",
          label: "Yuklamalar (Oktyabr)",
          children: [
            { name: "okt-ishchi-oquv", label: "Ishchi o'quv rejalar", to: { name: "okt-ishchi-oquv" } },
            {
              name: "okt-kafedra-yuklamalari",
              label: "Kafedra yuklamalari",
              to: { name: "okt-kafedra-yuklamalari" },
            },
            { name: "okt-kafedra-taqsimoti", label: "Kafedra taqsimoti", to: { name: "okt-kafedra-taqsimoti" } },
            { 
              name: "okt-yuklama-va-taqsimot", 
              label: "Yuklama va taqsimot", 
              to: { name: "okt-yuklama-va-taqsimot" } 
            },
            { name: "okt-shaxsiy-ish", label: "Shaxsiy ish reja", to: { name: "okt-shaxsiy-ish-reja" } },
            { 
              name: "okt-kafedra-vs-shaxsiy-reja", 
              label: "Kafedra vs Shaxsiy ish reja", 
              to: { name: "okt-kafedra-vs-shaxsiy-reja" }, 
              superAdminOnly: true 
            },
            { name: "okt-tanlov-fanlar", label: "Tanlov fanlar", to: { name: "okt-tanlov-fanlar" } },
            { 
              name: "okt-faoliyat-jurnali", 
              label: "Faoliyat jurnali (Audit)", 
              to: { name: "okt-faoliyat-jurnali" }, 
              superAdminOnly: true 
            },
            { 
              name: "okt-backup", 
              label: "Baza nusxasi (Backup)", 
              to: { name: "okt-backup" }, 
              superAdminOnly: true 
            },
          ],
        },
      ],
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route && route.path && route.path.startsWith('/oktyabr')) {
          this.expandedGroups.yuklamalar_oktyabr = true;
        }
      }
    }
  },
created() {
  const userData = sessionStorage.getItem("user") || localStorage.getItem("user");
  if (userData && userData !== "undefined") {
    try {
      const parsed = JSON.parse(userData);
      this.userRole = parsed.role || "";
    } catch (e) {
      console.error("Error reading user data", e);
    }
  }
},
  computed: {
    currentUserRole() {
      if (this.userRole) return this.userRole;
      try {
        const userData = sessionStorage.getItem("user") || localStorage.getItem("user");
        if (userData && userData !== "undefined") {
          return JSON.parse(userData).role || "";
        }
      } catch (e) {}
      return "";
    },
    isOquvSuperAdmin() {
      try {
        const userData = sessionStorage.getItem("user") || localStorage.getItem("user");
        if (userData && userData !== "undefined") {
          const parsed = JSON.parse(userData);
          const phone = (parsed.phone || "").trim().toLowerCase();
          const name = (parsed.name || "").trim().toLowerCase();
          return phone === "oquvsuperadmin" || name === "oquvsuper admin";
        }
      } catch (e) {}
      return false;
    },
    isSuperAdmin() {
      const roleLower = (this.currentUserRole || '').trim().toLowerCase();
      return ['super admin', 'superadmin', 'admin', 'administrator'].includes(roleLower);
    },
    isDekan() {
      const roleLower = (this.currentUserRole || '').trim().toLowerCase();
      if (this.isSuperAdmin) return false;
      return ['dekan', 'dean', 'fakultet dekani'].some(r => roleLower.includes(r));
    },
    isKafedraMudir() {
      const roleLower = (this.currentUserRole || '').trim().toLowerCase();
      if (this.isSuperAdmin) return false;
      return ['kafedra mudiri', 'kafedra_mudiri', 'mudir'].some(r => roleLower.includes(r));
    },
    isTeacher() {
      const roleLower = (this.currentUserRole || '').trim().toLowerCase();
      if (this.isSuperAdmin || this.isKafedraMudir || this.isDekan) return false;
      return [
        'qituvchi',
        'teacher',
        'assistent',
        'assistant',
        'dotsent',
        'docent',
        'professor',
        'stajyor',
        'foydalanuvchi',
        'user'
      ].some(r => roleLower.includes(r));
    },
    isProrektor() {
      const roleLower = (this.currentUserRole || '').trim().toLowerCase();
      return roleLower.includes('prorektor');
    },
    filteredMenuItems() {
      // Dekan, O'qituvchi va Prorektor uchun faqat Shaxsiy ish reja
      if (this.isDekan || this.isTeacher || this.isProrektor) {
        return this.menuItems.map(group => {
          const filteredChildren = group.children.filter(child => child.name === 'shaxsiy-ish' || child.name === 'okt-shaxsiy-ish');
          return { ...group, children: filteredChildren };
        }).filter(group => group.children.length > 0);
      }

      // Kafedra mudiri uchun: Kafedra taqsimoti, Yuklama va taqsimot, va Shaxsiy ish reja
      if (this.isKafedraMudir) {
        return this.menuItems.map(group => {
          const filteredChildren = group.children.filter(child => 
            child.name === 'kafedra-taqsimoti' || 
            child.name === 'yuklama-va-taqsimot' || 
            child.name === 'shaxsiy-ish' ||
            child.name === 'okt-kafedra-taqsimoti' || 
            child.name === 'okt-yuklama-va-taqsimot' || 
            child.name === 'okt-shaxsiy-ish'
          );
          return { ...group, children: filteredChildren };
        }).filter(group => group.children.length > 0);
      }

      // Hide superAdminOnly and oquvSuperAdminOnly items
      return this.menuItems.map(group => {
        const filteredChildren = group.children.filter(child => {
          if (child.superAdminOnly && !this.isSuperAdmin) {
            return false;
          }
          if (child.oquvSuperAdminOnly && !this.isOquvSuperAdmin) {
            return false;
          }
          return true;
        });
        return { ...group, children: filteredChildren };
      });
    },
  },
  methods: {
    toggleGroup(name) {
      this.expandedGroups[name] = !this.expandedGroups[name];
    },
    isActive(to) {
      if (!to) return false;
      if (to.name) return this.$route.name === to.name;
      return this.$route.path === to;
    },
  },
};
</script>

<style scoped>
.sidebar-container {
  width: 260px;
  background-color: #0f172a; /* Slate 900 */
  color: #f8fafc;
  height: 100vh;
  display: flex;
  flex-direction: column;
  box-shadow: 4px 0 24px rgba(0, 0, 0, 0.2);
  font-family: 'Inter', sans-serif;
  z-index: 100;
}

/* Brand Section */
.brand-section {
  padding: 24px;
  display: flex;
  align-items: center;
  gap: 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  margin-bottom: 12px;
}

.brand-logo {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
}

.logo-inner {
  font-weight: 800;
  font-size: 12px;
  letter-spacing: -0.3px;
  color: white;
}

.brand-info {
  display: flex;
  flex-direction: column;
}

.brand-name {
  font-weight: 700;
  font-size: 14px;
  line-height: 1.25;
  letter-spacing: -0.2px;
}

.brand-tag {
  font-size: 10px;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Navigation */
.sidebar-nav {
  flex: 1;
  padding: 0 12px;
  overflow-y: auto;
}

.nav-group {
  margin-bottom: 8px;
}

.group-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
  background: rgba(255, 255, 255, 0.03);
}

.group-header:hover {
  background: rgba(255, 255, 255, 0.08);
}

.group-icon {
  font-size: 18px;
}

.group-label {
  flex: 1;
  font-weight: 600;
  font-size: 14px;
  color: #e2e8f0;
}

.chevron-icon {
  width: 14px;
  height: 14px;
  color: #64748b;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.chevron-icon.rotated {
  transform: rotate(90deg);
  color: #3b82f6;
}

/* Children */
.group-children {
  margin-top: 4px;
  padding-left: 12px;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.child-link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  font-size: 13px;
  color: #94a3b8;
  border-radius: 10px;
  text-decoration: none;
  transition: all 0.2s ease;
  position: relative;
}

.child-dot {
  width: 6px;
  height: 6px;
  background: #334155;
  border-radius: 50%;
  transition: all 0.2s ease;
}

.child-link:hover {
  color: #f8fafc;
  background: rgba(255, 255, 255, 0.04);
}

.child-link:hover .child-dot {
  background: #475569;
  transform: scale(1.2);
}

.child-link.active {
  color: #fff;
  background: linear-gradient(90deg, rgba(59, 130, 246, 0.15) 0%, transparent 100%);
  font-weight: 600;
}

.child-link.active .child-dot {
  background: #3b82f6;
  box-shadow: 0 0 8px rgba(59, 130, 246, 0.6);
  transform: scale(1.3);
}

.child-link.disabled {
  opacity: 0.6;
  cursor: default;
}

/* Footer */
.sidebar-footer {
  padding: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.footer-status {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 11px;
  color: #64748b;
  font-weight: 500;
}

.status-indicator {
  width: 8px;
  height: 8px;
  background-color: #10b981;
  border-radius: 50%;
  box-shadow: 0 0 8px rgba(16, 185, 129, 0.4);
}

/* Transitions */
.expand-enter-active, .expand-leave-active {
  transition: all 0.3s ease;
  max-height: 400px;
  overflow: hidden;
}
.expand-enter-from, .expand-leave-to {
  max-height: 0;
  opacity: 0;
  transform: translateY(-10px);
}
</style>
